module.exports = __webpack_public_path__ + "static/media/em-116.538fe7ae.png";